// src/components/common/MantenimientoForm.js
//
// Estructura comun de las pantallas de mantenimiento: encabezado con volver,
// barra de guardar arriba y abajo, y el contenido del formulario en el medio.
// El boton guardar se deshabilita cuando la pagina es solo lectura.

import PageHeader from "./PageHeader";
import SaveButtonBar from "./SaveButtonBar";

const MantenimientoForm = ({
    title,
    backTo,
    onSave,
    disabled = false,
    saveText = "Guardar",
    showSave = true,
    children,
}) => {
    return (
        <div>
            <PageHeader title={title} backTo={backTo} />

            {showSave && <SaveButtonBar text={saveText} onClick={onSave} disabled={disabled} />}

            {children}

            {showSave && <SaveButtonBar text={saveText} onClick={onSave} disabled={disabled} />}
        </div>
    );
};

export default MantenimientoForm;